// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation__scrim {
  height: 100vh;
  width: 100vw;
  background-color: #000;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  transition: opacity 0.3s linear;
  pointer-events: none;
}

.section-one,
.section-two {
  padding-top: 85px;
  height: 100vh;
}

.section-container {
  position: relative;
  max-width: 1240px;
  min-height: 560px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  padding: 10px 0;
}
.section-container .sectionOne-left {
  padding: 0;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.section-container .discover-more {
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
}

.bg-light-blue {
  background: #e8ecfc;
}

.bg-combination-blue {
  background: linear-gradient(to bottom, #1c2640 0%, #1c2640 65%, #dfe4fb 35%, #dfe4fb 100%);
}

.text-primary {
  color: #1c2640 !important;
}

.text-orange {
  color: #ec6927 !important;
}

.text-white {
  color: #ffffff !important;
}

.schedule-demo-btn {
  width: 133px;
  height: 36px;
  background: #ec6927 !important;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  color: white;
  cursor: pointer;
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #ffffff !important;
}

.register-btn {
  width: 133px;
  height: 36px;
  background: #1c2640 !important;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  color: #ffffff !important;
  cursor: pointer;
  font-family: Roboto;
  font-style: normal;
  font-size: 15px;
  line-height: 20px;
  margin-left: 20px;
}

button {
  transition: 0.25s !important;
}
button:hover, button:focus {
  box-shadow: 0 0.5em 0.5em -0.4em #000000 !important;
  transform: translateY(-0.25em) !important;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAoBA;EACC,aAAA;EACG,YAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,+BAAA;EACA,oBAAA;AAnBJ;;AAwBA;;EAEC,iBAAA;EACA,aAAA;AArBD;;AAwBA;EACC,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AArBD;AAuBC;EACC,UAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AArBF;AAwBC;EACC,eAAA;EACA,eAAA;EACA,gBAAA;AAtBF;;AA0BA;EACC,mBA7DW;AAsCZ;;AA0BA;EACC,0FAhEkB;AAyCnB;;AA0BA;EACC,yBAAA;AAvBD;;AA0BA;EACC,yBAAA;AAvBD;;AA0BA;EACC,yBAAA;AAvBD;;AA0BA;EACC,YAAA;EACA,YAAA;EACA,8BAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAvBD;;AA0BA;EACC,YAAA;EACA,YAAA;EACA,8BAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAvBD;;AA0BA;EACC,4BAAA;AAvBD;AAyBC;EAEC,mDAAA;EACA,yCAAA;AAxBF","sourcesContent":["// text\n$text-primary: #1c2640;\n$text-orange: #ec6927;\n$text-white: #ffffff;\n\n//background\n$ligt-blue: #e8ecfc;\n$combination-blue: linear-gradient(\n\tto bottom,\n\t#1c2640 0%,\n\t#1c2640 65%,\n\t#dfe4fb 35%,\n\t#dfe4fb 100%\n);\n\n//button\n$orange: #ec6927;\n$primary: #1c2640;\n\n\n.navigation__scrim{\n\theight: 100vh;\n    width: 100vw;\n    background-color: #000;\n    opacity: 0;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 99;\n    transition: opacity .3s linear;\n    pointer-events: none;\n}\n\n\n\n.section-one,\n.section-two {\n\tpadding-top: 85px;\n\theight: 100vh;\n}\n\n.section-container {\n\tposition: relative;\n\tmax-width: 1240px;\n\tmin-height: 560px;\n\twidth: 100%;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tdisplay: flex;\n\tpadding: 10px 0;\n\n\t.sectionOne-left {\n\t\tpadding: 0;\n\t\twidth: 50%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t}\n\n\t.discover-more {\n\t\tcursor: pointer;\n\t\tfont-size: 15px;\n\t\tfont-weight: 500;\n\t}\n}\n\n.bg-light-blue {\n\tbackground: $ligt-blue;\n}\n\n.bg-combination-blue {\n\tbackground: $combination-blue;\n}\n\n.text-primary {\n\tcolor: $text-primary !important;\n}\n\n.text-orange {\n\tcolor: $text-orange !important;\n}\n\n.text-white {\n\tcolor: $text-white !important;\n}\n\n.schedule-demo-btn {\n\twidth: 133px;\n\theight: 36px;\n\tbackground: #ec6927 !important;\n\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\tborder-radius: 3px;\n\tborder: none;\n\tcolor: white;\n\tcursor: pointer;\n\tfont-family: Roboto;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tcolor: #ffffff !important;\n}\n\n.register-btn {\n\twidth: 133px;\n\theight: 36px;\n\tbackground: $primary !important;\n\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\tborder-radius: 3px;\n\tborder: none;\n\tcolor: $text-white !important;\n\tcursor: pointer;\n\tfont-family: Roboto;\n\tfont-style: normal;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tmargin-left: 20px;\n}\n\nbutton {\n\ttransition: 0.25s !important;\n\n\t&:hover,\n\t&:focus {\n\t\tbox-shadow: 0 0.5em 0.5em -0.4em #000000 !important;\n\t\ttransform: translateY(-0.25em) !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
